import keycloak from "@evercam/shared/plugins/keycloak"
import { defineNuxtPlugin } from "#app"

export default defineNuxtPlugin(keycloak)
